/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { FETCH_SDCCA_PAYMENTS } from './actionTypes';

import { fetchSdccaPaymentsUtil } from './utils';

/**
 * Contains the action creator functions that update the SDCCAPayments slice of the store.
 *
 * @namespace SDCCAPaymentsActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/sdcca_payments
   *
   * @param {any} callback function to call once this function has finished
   * @function
   * @memberof SDCCAPaymentsActions
   */
  static fetchSdccaPayments = (dispatch, callback) => {
    ReduxUtils.generateAction(dispatch, fetchSdccaPaymentsUtil, FETCH_SDCCA_PAYMENTS, callback);
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to fetchSdccaPayments.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof SDCCAPaymentsActions
   */
  static resetFetchSdccaPayments = (dispatch, data) => {
    const json = {
      type: FETCH_SDCCA_PAYMENTS.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to fetchSdccaPayments.
   *
   * @param {function} dispatch
   * @function
   * @memberof SDCCAPaymentsActions
   */
  static resetFetchSdccaPaymentsError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, FETCH_SDCCA_PAYMENTS.failureAction);
  };
}
